<ng-content select="[header]"></ng-content>

<i class="material-icons-round" [ngClass]="{ expanded: expanded }">
  chevron_right
</i>
